module.exports = __webpack_public_path__ + "static/media/web-code-link.02812878.svg";